/* webpack-strip-block:removed */

const RATING_CONFIG = 'data-rating-star';
const STARS_CONFIG = {
    SIZE: 'data-stars-size',
    COLOR: 'data-stars-color',
    MESSAGE: 'data-stars-message',
};

// const SIZES = ['main', 'none', 'tiny', 'small', 'xmain', 'big', 'large', 'mlarge', 'xlarge', 'xxlarge', 'huge'];

export class RatingStars {
    // Building Stars HTML
    static stars(rating, size) {
        let res = '';
        let on = 0.24;
        let half = 0.75;

        for (let i = 0; i < 5; i++) {
            res += `<span class="f-stars ${rating > on ? 'on' : ''}">
                            <i class="fa fa-star${rating < half && rating > on ? '_half' : ''} ${size}"></i>
                        </span>`;
            on += 1;
            half += 1;
        }

        return res;
    }

    // Building Stars Wrapper
    static ratingStarsWrapper(element) {
        // Getting data-rating-star value of the element
        let rating = null;

        try {
            rating = parseFloat(element.getAttribute(RATING_CONFIG));
        } catch (e) {
            throw new Error('Component must have "data-rating-star" attribute');
        }

        const size = element.getAttribute(STARS_CONFIG.SIZE) || '';
        const color = element.getAttribute(STARS_CONFIG.COLOR) || '';
        const message = element.getAttribute(STARS_CONFIG.MESSAGE) || '';

        return `
                <span aria-hidden="true" class="f-rating-stars u-mr1 ${size} ${color}" title="${message}">
                    ${RatingStars.stars(rating, size)}
                </span>
            `;
    }

    constructor(root = document) {
        // Getting all elements with data-rating-star attribute
        const elements = root.querySelectorAll(`[${RATING_CONFIG}]`);

        // Running function over all elements
        elements.forEach((element) => {
            if (element.querySelector('.f-rating-stars') === null) {
                element.insertAdjacentHTML('beforeend', RatingStars.ratingStarsWrapper(element));
            }
        });
    }
}
